import { useGetPatientReminderHistoryQuery } from "app/store/patient/api/patientApi";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

const useReminderHistoryLog = () => {
  const dispatch = useDispatch();
  const { patient } = useSelector((state) => state.nonCompliantPatient);

  const { data, isLoading, isFetching } = useGetPatientReminderHistoryQuery({
    patientId: patient?._id,
  });

  return { data, isLoading, isFetching, dispatch };
};

export default useReminderHistoryLog;
